import { connect } from "react-redux";
import {
	onList,
	onAdd,
	onSave,
	onRemove
} from "../actions";
import LeaveType from "./leave-type";

const mapStateToProps = ({ leaveTypes }) => ({
	leaveTypes: leaveTypes.data,
	isLoadingList: leaveTypes.isLoadingList
});

const mapDispatchToProps = {
	onList,
	onAdd,
	onSave,
	onRemove
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaveType);
export { default as LeaveTypeListing } from "./leave-type-listing";
